import React from 'react';
import cn from 'classname';

const isEverad = process.env.CPA_ENV === 'everad';

class Row extends React.Component {
	constructor(props) {
		super(props);
		this.state = { isOpenedComment: false, isOpenedAnalComment: false  };
		this.toggleCommentOpen = this.toggleCommentOpen.bind(this);
		this.toggleAnalCommentOpen = this.toggleAnalCommentOpen.bind(this);
	}

	toggleCommentOpen() {
		this.setState(state => ({ ...state, isOpenedComment: !state.isOpenedComment }));
	}
	toggleAnalCommentOpen() {
		this.setState(state => ({ ...state, isOpenedAnalComment: !state.isOpenedAnalComment }));
	}
	render() {
		const { row, can, index, markRisked } = this.props;

		const isLessPayout = Number(row.current_payout) > (Number(row.payout_decision) || Number(row.amount));

		const commentsSliced = !!row.comment && row.comment.split('\n')
			.filter(Boolean)
			.map((com, ind) => <p key={ind}>{com}</p>)
			.slice(0, this.state.isOpenedComment ? 1000 : 3);

		const analyticCommentsSliced = row.analytic_comment && row.analytic_comment.split('\n')
			.filter(Boolean)
			.map((com, ind) => <p key={ind}>{com}</p>)
			.slice(0, this.state.isOpenedAnalComment ? 1000 : 3);

		return (
			<tr className={cn({
				'modify-background': !!(index % 2),
				'payout-less': isLessPayout || row.status === 'rejected',
				'payout-agreed': row.status === 'agreed',
				'was-reviewed': !!row.reviewed_at && row.status === 'review'
			})}>
				<td className="short-id-col">
					<p>{row.id}</p>
					{ row.is_traffic_scaling && <p>{'Traff scale payout!'}</p>}
				</td>
				<td className="small-cell">
					<p className="margin-top-5">
						{row.created_at_date}
					</p>
					<p className="margin-top-5">
						{row.created_at_time}
					</p>
				</td>
				<td>{row.manager}</td>
				<td className="aff-col">
					<div>
						<p className="margin-top-5">{row.affiliate_id}</p>
						<p className="margin-top-5">{row.offer}</p>
						<p className="margin-top-5">{row.country}</p>
					</div>
				</td>
				<td className="text-center short-col">{row.has_conversions ? '✔' : '-'}</td>
				<td>
					{row.sid ? `${row.sid} ${row.sid_type ? `(${row.sid_type})` : ''} & ` : ''}  {row.campaign_id}
				</td>
				<td className="short-col">{Number(row.last_amount) || Number(row.current_payout)} $</td>
				<td className="text-center short-col">
					{
						row.amount === null ? 'Max' : <span className="margin-right-10">{Number(row.amount)} $</span>
					}
				</td>
				<td className="short-col">{Number(row.garant_percent)}</td>
				<td className="text-center">{row.traffic_source}</td>
				<td className="text-center short-col">{Number(row.planned_volume)}</td>
				<td className={cn({ 'analitic-cell': true, 'text-center': true, 'short-col': true })}>
					<span className="margin-right-10">{Number(row.payout_decision) || '-'}</span>
				</td>
				<td className={cn({ 'analitic-cell': true, 'short-col': true, 'text-center': true })}>
					<span>{Number(row.granted_volume) || '-'}</span>
				</td>
				<td
					className="text-center"
					onMouseEnter={this.toggleCommentOpen}
					onMouseLeave={this.toggleCommentOpen}
				>
					<div className="flex-center padding-0-15">
						<span className="margin-right-10">
							{
								commentsSliced
							}
							{
								!!row.comment &&
								!!row.comment.length &&
								(commentsSliced.length !== row.comment.split('\n').filter(a => !!a).length) &&
								'...'
							}
						</span>
					</div>
				</td>
				<td
					className={cn({ 'analitic-cell': can('payout_requests_review'), 'text-center': true })}
					onMouseEnter={this.toggleAnalCommentOpen}
					onMouseLeave={this.toggleAnalCommentOpen}
				>
					<div className="display-flex justify-content-between padding-0-15">
						<span className="margin-right-10">
							{
								analyticCommentsSliced
							}
							{
								!!row.analytic_comment &&
								!!row.analytic_comment.split('\n').length &&
								analyticCommentsSliced.length !== row.analytic_comment.split('\n').filter(a => !!a).length &&
								'...'
							}
						</span>
					</div>
				</td>
				<td>
					<div className="display-flex-column flex-center">
						<span>{row.status}</span>
						{
							can('payout_requests_review') &&
							isEverad &&
								<a
									className={'margin-10-0 ' + (row.is_risk ? 'action_mark_risked' : 'action_mark_risked_inactive')}
									href="#"
									onClick={e => {
										e.preventDefault();
										markRisked(row.id);
									}}
								/>
						}
					</div>
				</td>
			</tr>
		);
	}
}

export default Row;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/payout-requests/components/table-request-history/row.js